// extracted by mini-css-extract-plugin
export var dropdownIcon = "_s7-6";
export var imgContainer = "_s7-3";
export var menuIcon = "_s7-5";
export var pillWrapper = "_s7-2";
export var pillsContainer = "_s7-1";
export var subscriptionCard = "_s7-0";
export var subscriptionLogo = "_s7-4";